import React from 'react';
import _ from 'lodash';

const MadelungConstants = (props) => {
  const { madelung } = props.structure;
  const { wyckoffsDetail } = props.structure.relaxedStructure;
  if (!madelung.constants) {
    return null;
  }

  const madelungTable = {};

  madelung.constants.forEach((obj, index) => {
    if (!madelungTable[obj.element]) {
      madelungTable[obj.element] = {};
    }
    if (!madelungTable[obj.element][wyckoffsDetail[index]]) {
      madelungTable[obj.element][wyckoffsDetail[index]] = {
        pot: [],
        cons: []
      };
    }
    madelungTable[obj.element][wyckoffsDetail[index]].pot.push(obj.pot);
    madelungTable[obj.element][wyckoffsDetail[index]].cons.push(obj.cons);
    return;
  });

  return (
    <table className="table table-sm text-right">
      <thead className="thead-light">
        <tr>
          <th className="text-center">Element</th>
          <th className="text-center">Wikoff</th>
          <th className="text-center">Pot (V)</th>
          <th className="text-center">Constant</th>

        </tr>
      </thead>
      <tbody>
        { _.map(madelungTable, (madelungItem, elm) =>
          _.map(madelungItem, (values, wyckoff) => {
            const pot = values.pot.reduce((a, b) => Number(a) + Number(b)) / values.pot.length;
            const cons = values.cons.reduce((a, b) => Number(a) + Number(b)) / values.cons.length;
            return <tr key={`${elm}-${wyckoff}`}>
              <td className="text-center">{elm}</td>
              <td className="text-center">{values.cons.length}{wyckoff}</td>
              <td className="text-center">{pot.toFixed(3)}</td>
              <td className="text-center">{cons.toFixed(3)}</td>
            </tr>
          }))
        }
      </tbody>
    </table>
  );
}

export default MadelungConstants;



// WEBPACK FOOTER //
// ./src/containers/structures/madelungConstants.js